import React, {Component} from 'react';
import SuccessComponent from '../SuccessComponent/SuccessComponent';

class SuccessPageComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emailAddress: this.props.emailAddress,
            currentPage: this.props.currentPage
        };
    }

    render() {
        return (
            <SuccessComponent
                lingua={this.props.lingua}
                emailAddress={this.props.emailAddress}
                firstName={this.props.firstName}
                onClose={this.props.onClose}
            />
        );
    }
}

export default SuccessPageComponent;
